export const ColumnasReportes = [
    {
        id: 'idIndex',
        value: 'idIndex',
        name: 'N° OT',
        index: null,
        checked: true,
        isDate: false,
        width: 100,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'machine',
        value: 'machine',
        name: 'Máquina',
        index: null,
        checked: true,
        isDate: false,
        width: 80,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'hourMeter',
        value: 'hourMeter',
        name: 'Horómetro',
        index: null,
        checked: true,
        isDate: false,
        width: 90
    },
    {
        id: 'guide',
        value: 'guide',
        name: 'Pauta',
        index: null,
        checked: true,
        isDate: false,
        width: 75,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'idPm',
        value: 'idPm',
        name: 'SPM',
        index: null,
        checked: true,
        isDate: false,
        width: 100,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'model',
        value: 'model',
        name: 'Flota',
        index: null,
        checked: true,
        isDate: false,
        width: 100,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'progress',
        value: 'progress',
        name: 'Progreso',
        index: null,
        checked: true,
        isDate: false,
        width: 80,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'datePrev',
        value: 'datePrev',
        name: 'Fecha Prevista',
        index: null,
        checked: true,
        isDate: true,
        width: 100,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'dateInit',
        value: 'dateInit',
        name: 'Fecha Inicio',
        index: null,
        checked: true,
        isDate: true,
        width: 100,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'endReport',
        value: 'endReport',
        name: 'Fecha Término',
        index: null,
        checked: true,
        isDate: true,
        width: 100,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'dateClose',
        value: 'dateClose',
        name: 'Fecha Cierre',
        index: null,
        checked: true,
        isDate: true,
        width: 100,
        restrict: ['Completadas', 'Revisión SAP']
    },
    {
        id: 'estado',
        value: 'estado',
        name: 'Estado',
        index: null,
        checked: true,
        isDate: false,
        width: 100,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'hallazgosCount',
        value: 'hallazgosCount',
        name: 'Hallazgos',
        index: null,
        checked: true,
        isDate: false,
        width: 100,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'noChecksCount',
        value: 'noChecksCount',
        name: 'Sin Ejecutar',
        index: null,
        checked: true,
        isDate: false,
        width: 100,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'sapId',
        value: 'sapId',
        name: 'OM SAP',
        index: null,
        checked: true,
        isDate: false,
        width: 150,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'usersAssigned',
        value: 'usersAssigned',
        name: 'Asignado a',
        index: null,
        checked: true,
        isDate: false,
        width: 150,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'assignedBy',
        value: 'assignedBy',
        name: 'Asignado por',
        index: null,
        checked: true,
        isDate: false,
        width: 150,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'shiftManagerApprovedBy',
        value: 'shiftManagerApprovedBy',
        name: 'Jefe de turno',
        index: null,
        checked: true,
        isDate: false,
        width: 150,
        restrict: ['En proceso', 'Por cerrar', 'Completadas', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'chiefMachineryApprovedBy',
        value: 'chiefMachineryApprovedBy',
        name: 'Jefe de Maquinaria',
        index: null,
        checked: true,
        isDate: false,
        width: 150,
        restrict: ['Por cerrar', 'Completadas', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'sapExecutiveApprovedBy',
        value: 'sapExecutiveApprovedBy',
        name: 'Ejecutivo SAP',
        index: null,
        checked: true,
        isDate: false,
        width: 150,
        restrict: ['Completadas', 'Revisión SAP']
    },
    {
        id: 'site',
        value: 'site',
        name: 'ID Obra',
        index: null,
        checked: true,
        isDate: false,
        width: 65,
        restrict: ['Origen', 'Asignar', 'En proceso', 'Por cerrar', 'Completadas', 'Ejecutando por operador', 'Reasignar', 'Revisión Supervisor', 'Revisión J. Maquinaria', 'Revisión SAP']
    },
    {
        id: 'urlPdf',
        value: 'urlPdf',
        name: 'Download',
        index: null,
        checked: true,
        isDate: false,
        width: 80,
        restrict: ['Completadas', 'Revisión SAP']
    }
]
